import React, { useEffect, useMemo, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
	getPromoPortfolioSectorsAdmin,
	deletePromoPortfolioSector,
	movePromoPortfolioSector,
} from "../../../../api/promo-portfolio-sector";
import {
	Button,
	Tooltip,
	Chip,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import { buttonsStyle } from "../../../components/tables/table";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";

export default function PromoPortfolioSectorsPage() {
	const [sectors, setSectors] = useState([]);
	const [sectorId, setSectorId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [movingId, setMovingId] = useState(null);
	const history = useHistory();

	const sorted = useMemo(
		() =>
			[...(sectors || [])].sort(
				(a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || String(a.name).localeCompare(String(b.name))
			),
		[sectors]
	);

	useEffect(() => {
		let mounted = true;
		getPromoPortfolioSectorsAdmin()
			.then((res) => {
				if (!mounted) return;
				if (res.status === 200) setSectors(res.data || []);
			})
			.catch((error) => {
				if (!mounted) return;
				alertError({ error, customMessage: "No se pudieron cargar los sectores." });
			})
			.finally(() => {
				if (mounted) setRefresh(false);
			});
		return () => {
			mounted = false;
		};
	}, [refresh]);

	const handleMove = (id, direction) => {
		setMovingId(id);
		movePromoPortfolioSector(id, direction)
			.then((res) => {
				if (res.status === 200) setRefresh(true);
			})
			.catch((error) => {
				alertError({ error, customMessage: "No se pudo cambiar el orden." });
			})
			.finally(() => setMovingId(null));
	};

	return (
		<>
			<Card>
				<CardHeader title="Sectores portfolio (web)">
					<CardHeaderToolbar>
						<Button
							variant="outlined"
							color="default"
							style={{ marginRight: 8 }}
							onClick={() => history.push("/promo-portfolio-projects")}
						>
							Volver a proyectos
						</Button>
						<Button
							variant="contained"
							color="primary"
							onClick={() => history.push("/edit-promo-portfolio-sector")}
						>
							Nuevo sector
						</Button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					{sorted.length === 0 ? (
						<Typography color="textSecondary">No hay sectores. Crea el primero con «Nuevo sector».</Typography>
					) : (
						<TableContainer component={Paper} variant="outlined">
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Nombre</TableCell>
										<TableCell width={100}>Estado</TableCell>
										<TableCell width={200} align="right">
											Acciones
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{sorted.map((sector, index) => {
										const id = sector._id;
										const isFirst = index === 0;
										const isLast = index === sorted.length - 1;
										const active = sector.active !== false;
										return (
											<TableRow key={id}>
												<TableCell>{sector.name}</TableCell>
												<TableCell>
													{active ? (
														<Chip label="Activo" size="small" style={{ background: "#1bc5bd", color: "#fff" }} />
													) : (
														<Chip label="Inactivo" size="small" />
													)}
												</TableCell>
												<TableCell align="right">
													<Tooltip title="Editar">
														<Button
															size="small"
															style={buttonsStyle}
															onClick={() => history.push("/edit-promo-portfolio-sector/" + id)}
														>
															<EditIcon />
														</Button>
													</Tooltip>
													<Tooltip title="Eliminar">
														<Button
															size="small"
															style={buttonsStyle}
															onClick={() => {
																setSectorId(id);
																setOpenConfirmDialog(true);
															}}
														>
															<DeleteIcon />
														</Button>
													</Tooltip>
													<Tooltip title="Subir">
														<span>
															<Button
																size="small"
																style={buttonsStyle}
																disabled={isFirst || movingId === id}
																onClick={() => handleMove(id, "up")}
															>
																<ArrowUpwardIcon fontSize="small" />
															</Button>
														</span>
													</Tooltip>
													<Tooltip title="Bajar">
														<span>
															<Button
																size="small"
																style={buttonsStyle}
																disabled={isLast || movingId === id}
																onClick={() => handleMove(id, "down")}
															>
																<ArrowDownwardIcon fontSize="small" />
															</Button>
														</span>
													</Tooltip>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					)}
					<ConfirmDialog
						title="¿Seguro que quieres eliminar este sector?"
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deletePromoPortfolioSector(sectorId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({ title: "Eliminado", customMessage: "Sector eliminado correctamente." });
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error, customMessage: "No se pudo eliminar el sector." });
								})
								.finally(() => {
									setOpenConfirmDialog(false);
									setSectorId(null);
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
